import React, { useState } from 'react';
import classnames from 'classnames/bind';
import { SingleValue } from 'react-select';

import BaseModal from '@MODALS/BaseModal';
import BasicSelect from '@COMPONENTS/COMMON/inputs/select/inputs/BasicSelect';
import BasicButton from '@COMPONENTS/COMMON/buttons/BasicButton';
import PermissionTable from './PermissionTable';

import styles from './PermissionModal.module.scss';

const cx: CX = classnames.bind(styles);

function PermissionModal(props: any) {
    const {
        options, usersData, addUser, handleCheckboxChange, removeUser, savePermissions, handleClose,
    } = props;

    const [selectedUser, setSelectedUser] = useState<any>(null);

    const handleUserChange = (newValue: SingleValue<any>) => {
        setSelectedUser(newValue);
    };

    const handleAddUser = () => {
        if (selectedUser) {
            // Find the user object from the original options using the selected user ID
            const userToAdd = options.find((user: any) => user.id === selectedUser.value);
            if (userToAdd) {
                addUser(userToAdd);
                setSelectedUser(null);
            }
        }
    };

    const handleDeleteUser = (userId: number) => {
        removeUser(userId);
    };

    // Transform options to work with BasicSelect - follow the exact pattern from DocumentPermissionsControls
    const selectOptions = options.map((user: any) => {
        const { icon, ...userWithoutIcon } = user; // Remove the React component icon
        return {
            ...userWithoutIcon,
            value: user.id,
            label: user.label || user.fullName || user.email,
        };
    });

    // Debug logging
    console.log('PermissionModal Debug:', {
        originalOptionsCount: options.length,
        selectOptionsCount: selectOptions.length,
        firstOriginalOption: options[0],
        firstSelectOption: selectOptions[0],
        hasIcon: options[0] && 'icon' in options[0],
    });

    return (
        <BaseModal onClose={handleClose}>
            <div className={cx('permission-modal')}>
                <div className={cx('modal-header')}>
                    <h2>Manage Permissions</h2>
                    <button
                        type="button"
                        className={cx('close-button')}
                        onClick={handleClose}
                    >
                        &times;
                    </button>
                </div>

                <div className={cx('modal-content')}>
                    <div className={cx('search-section')}>
                        <div className={cx('search-input')}>
                            <BasicSelect
                                title="Select User"
                                placeholder="Choose a user to add..."
                                options={selectOptions}
                                value={selectedUser}
                                onChange={handleUserChange}
                                isSearchable
                                isClearable
                                menuPosition="absolute"
                                menuPlacement="bottom"
                            />
                        </div>
                        <div className={cx('add-button')}>
                            <BasicButton
                                variant="primary"
                                size="medium"
                                title="Add User"
                                locked={!selectedUser}
                                onClick={handleAddUser}
                            />
                        </div>
                    </div>

                    <div className={cx('permissions-section')}>
                        <PermissionTable
                            users={usersData}
                            handlecheckboxChange={handleCheckboxChange}
                            handleDeleteUser={handleDeleteUser}
                        />
                    </div>
                </div>

                <div className={cx('modal-actions')}>
                    <BasicButton
                        variant="neutral"
                        size="medium"
                        title="Cancel"
                        onClick={handleClose}
                        style={{ flex: 1 }}
                    />
                    <BasicButton
                        variant="success"
                        size="medium"
                        title="Save Permissions"
                        onClick={savePermissions}
                        style={{ flex: 1 }}
                    />
                </div>
            </div>
        </BaseModal>
    );
}

export default PermissionModal;
